export default __webpack_public_path__ + "static/media/window-cleaning.fb26909a.jpeg";